import { withPresetIconProps } from './withPresetIconProps';
import BoldIcon from '@wix/da-ds/pkg/Icons/24x24/Bold';
import ItalicIcon from '@wix/da-ds/pkg/Icons/24x24/Italic';
import UnderlineIcon from '@wix/da-ds/pkg/Icons/24x24/Underline';
import QuoteIcon from '@wix/da-ds/pkg/Icons/24x24/Quote';
import LeftAlignIcon from '@wix/da-ds/pkg/Icons/24x24/LeftAlign';
import CenterAlignIcon from '@wix/da-ds/pkg/Icons/24x24/CenterAlign';
import RightAlignIcon from '@wix/da-ds/pkg/Icons/24x24/RightAlign';
import BlockAlignIcon from '@wix/da-ds/pkg/Icons/24x24/BlockAlign';
import NumberedListIcon from '@wix/da-ds/pkg/Icons/24x24/NumberedList';
import BulletListIcon from '@wix/da-ds/pkg/Icons/24x24/BulletList';
import TextSizeIcon from '@wix/da-ds/pkg/Icons/24x24/TextSize';
import GifIcon from '@wix/da-ds/pkg/Icons/24x24/AddGif';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import AddImageIcon from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import AddGalleryIcon from '@wix/da-ds/pkg/Icons/24x24/AddGallery';
import CenterImageIcon from '@wix/da-ds/pkg/Icons/24x24/CenterImage';
import FullWidthImageIcon from '@wix/da-ds/pkg/Icons/24x24/FullWidthImage';
import FloatLeftIcon from '@wix/da-ds/pkg/Icons/24x24/FloatLeft';
import FloatRightIcon from '@wix/da-ds/pkg/Icons/24x24/FloatRight';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import GalleryGridIcon from '@wix/da-ds/pkg/Icons/24x24/GalleryGrid';
import GalleryTorpedoIcon from '@wix/da-ds/pkg/Icons/24x24/GalleryTorpedo';
import SettingsIcon from '@wix/da-ds/pkg/Icons/24x24/Settings';
import RefreshIcon from '@wix/da-ds/pkg/Icons/24x24/Refresh';
export const Bold = withPresetIconProps(BoldIcon);
export const Italic = withPresetIconProps(ItalicIcon);
export const Underline = withPresetIconProps(UnderlineIcon);
export const Blockquote = withPresetIconProps(QuoteIcon);
export const AlignLeft = withPresetIconProps(LeftAlignIcon);
export const AlignCenter = withPresetIconProps(CenterAlignIcon);
export const AlignRight = withPresetIconProps(RightAlignIcon);
export const AlignJustify = withPresetIconProps(BlockAlignIcon);
export const OrderedList = withPresetIconProps(NumberedListIcon);
export const UnorderedList = withPresetIconProps(BulletListIcon);
export const TextSize = withPresetIconProps(TextSizeIcon);
export const inactiveIconTitle = TextSize;
export const TitleOne = TextSize;
export const TitleTwo = TextSize;
export const CenterImage = withPresetIconProps(CenterImageIcon);
export const FullWidthImage = withPresetIconProps(FullWidthImageIcon);
export const FloatLeft = withPresetIconProps(FloatLeftIcon);
export const FloatRight = withPresetIconProps(FloatRightIcon);
export const Edit = withPresetIconProps(EditIcon);
export const Delete = withPresetIconProps(TrashcanIcon);
export const GalleryGrid = withPresetIconProps(GalleryGridIcon);
export const GalleryTorpedo = withPresetIconProps(GalleryTorpedoIcon);
export const Settings = withPresetIconProps(SettingsIcon);
export const Link = withPresetIconProps(LinkIcon);
export const Gif = withPresetIconProps(GifIcon);
export const AddImage = withPresetIconProps(AddImageIcon);
export const AddVideo = withPresetIconProps(AddVideoIcon);
export const AddGallery = withPresetIconProps(AddGalleryIcon);
export const Refresh = withPresetIconProps(RefreshIcon);
